import { render, staticRenderFns } from "./TciAboutUs.vue?vue&type=template&id=f18ff820"
import script from "./TciAboutUs.vue?vue&type=script&lang=js"
export * from "./TciAboutUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports